import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { LoginBoxDialogOptions, LoginBoxDialogResult } from './loginbox-dialog';


@Component({
    selector: 'app-loginbox-dialog',
    styleUrls: ['./loginbox-dialog.component.scss'],
    templateUrl: './loginbox-dialog.component.html',
})
export class LoginBoxDialogComponent implements OnInit {
    CancelTried: boolean;
    title: string;
    message: string;
    oktext: string;
    canceltext: string;
    validators: ValidatorFn[] | null = null;
    username: string | null;

    loginForm!: UntypedFormGroup;

    constructor(
        private dialogRef: MatDialogRef<LoginBoxDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: LoginBoxDialogOptions,
        private fb: UntypedFormBuilder
    ) {
        this.CancelTried = false;
        this.title = data.TitleText || 'Credentials Required';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || 'OK';
        this.canceltext = data.CancelText || 'Cancel';
        this.validators = data.Validators || null;
        this.username = data.Username || null;
    }

    ngOnInit() {
        // Set up the form group
        this.loginForm = this.fb.group({
            username: [this.username],
            password: [null],
        });

        // If we were provided validators, set them now.
        if (this.validators && this.validators.length > 0) {
            const ctrl = this.loginForm.get('username');
            const toSet = [Validators.required, ...this.validators];

            if (ctrl) ctrl.setValidators(this.validators);
            this.loginForm.updateValueAndValidity();
        }
    }

    CancelHandler() {
        if (this.CancelTried !== true) {
            // Set the flag, so the user has to hit it a second time.
            this.CancelTried = true;
            return;
        }

        // Oh well. Close it.
        this.dialogRef.close(null);
    }

    OKHandler() {
        const response = this.loginForm.value;

        this.dialogRef.close({
            Username: response.username,
            Password: response.password,
        } as LoginBoxDialogResult);
    }
}
